
import React from 'react'
import './Tasks.css'
import TasksField from './TasksField/TasksField'

function Tasks({tasks}) {
  
  return (
    <div className="tasks">
        <h2 className="tasks__title">Задачи</h2>
        <TasksField
          tasks={tasks}
        />
    </div>
  );
}

export default Tasks;